import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class PaymentgetwayService {
  
  CreditCard = {
    id: 1, 
    cc: 'cc',
    name: 'Credit Card',
    credit_store_value: '0',
    credit_payment_type: 'CC',
    credit_value_card: '1',
    credit_value_payOption: "2"
  };

  DebitCard = {
    id: 2, 
    cc: 'dc',
    name: 'Debit Card',
    debit_store_value: '0',
    debit_payment_type: 'DC',
    debit_value_card: '2',
    debit_value_payOption: '3'
  };

  InternetBanking = {
    id: 3, 
    name: 'Internet Banking',
    internet_payment_type: 'NB',
    internet_category: 'netbanking',
    internet_pay_Option: '4'
  };

  WalletBanking = {
    id: 5, 
    name: 'Wallet Banking',
    wallet_payment_type: 'W',
    wallet_pay_Option: '5'
  };

  BelairTestPayment = {
    
  };
  UPIPAYMENT = {
    id: 7,
    name: 'UPI',
    upi_payment_type: 'UPI',
    upi_pay_option: '7'
  }

  getProcessedPaymentTabIndex(paymentTypes: string[], paymentMethod: any): any[] {
    if (!paymentMethod) return [];
  
    const processedTabs = paymentTypes.includes('upi_options')
      ? ['upi_options', ...paymentTypes.filter(type => type !== 'upi_options')]
      : paymentTypes;
  
    return processedTabs
    .filter(type => paymentMethod[type]?.length > 0)
    .map((type, index) => ({
      index,
      type,
      tabIndex: type === 'upi_options' ? 0 : index
    }));
  }

  getTabIndexForType(type: string, PAYMENTTABINDEX: any[]): number | null {
    return PAYMENTTABINDEX.find(tab => tab.type === type)?.tabIndex ?? null;
  }

  getFilteredPGOffer(offerData: any[], label: string): { isKeyPresent: boolean; paymentMethodKey: string | null; offerData: any[] } {
    const paymentMethodKey = label === 'UPI Payment' ? '7' : label === 'Credit Card' ? '2' : label === 'Internet Banking' ? '4' : label === 'Debit Card' ? '3' : label === 'EMI Payment' ? '6' : null;
    // console.log('Invalid or unhandled label:', offerData);
    if (!paymentMethodKey) {
      return { isKeyPresent: false, paymentMethodKey, offerData };
    }
    const isKeyPresent = offerData.some(item => 
      item?.supported_payment_methods && item.supported_payment_methods.hasOwnProperty(paymentMethodKey)
    );
    return { isKeyPresent, paymentMethodKey, offerData };
  }

}
